import type { InputHTMLAttributes } from 'react';
export const normalizeCode = (value: string) => value.replace(/[\s\u200B-\u200D\uFEFF]/g, '');
export function VerificationCodeInput({
  recovery = false,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & { recovery?: boolean }) {
  return (
    <input
      {...props}
      type="text"
      inputMode={recovery ? 'text' : 'numeric'}
      autoComplete="one-time-code"
      minLength={6}
      maxLength={recovery ? 20 : 12}
      pattern={recovery ? '([0-9]{6}|[A-Za-z0-9]{5}[-]?[A-Za-z0-9]{5})' : '[0-9]{6}'}
      title={
        recovery
          ? 'Enter a 6-digit authenticator code or a recovery code.'
          : 'Enter the 6-digit code from your email or authenticator.'
      }
      onInput={(event) => {
        event.currentTarget.value = normalizeCode(event.currentTarget.value);
        props.onInput?.(event);
      }}
      onPaste={(event) => {
        event.preventDefault();
        const input = event.currentTarget;
        const code = normalizeCode(event.clipboardData.getData('text'));
        input.setRangeText(
          code,
          input.selectionStart ?? 0,
          input.selectionEnd ?? input.value.length,
          'end',
        );
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }}
    />
  );
}
